import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Badge from 'ui/Badge';
import { useCurrentUser } from 'utils/user';

import BlockedMenuItem from '../BlockedMenuItem';
import TrackedMenuItem from '../TrackedMenuItem';

const ImportMenuItem: React.FC = () => {
  const { openSmartImportModal } = useGlobalModalsContext();
  const { user } = useCurrentUser();

  const badge = (
    <Badge ml="auto" size="sm">
      NEW
    </Badge>
  );

  if (!user?.can_create_sankeys) {
    return (
      <BlockedMenuItem
        value="import"
        label="Smart import"
        badge={badge}
        conversionTriggerAction="Importing"
        upgradeMessage="To import a new diagram please upgrade your subscription or delete some of your existing diagrams to free up more diagram slots."
      />
    );
  }

  return (
    <TrackedMenuItem value="import" onClick={openSmartImportModal}>
      Smart import {badge}
    </TrackedMenuItem>
  );
};

export default ImportMenuItem;
